import type { FilterSection } from "@/types/filterTypes";
import yearOptions from "@/utils/constants/yearOptions";

export const useHistoryFilterSections = (): FilterSection[] => {
  return [
      {
      key: "year",
      label: "Year",
      type: "select",
      placeholder: "Select Year",
      options: yearOptions
    },
    {
      key: "createdStartDate",
      label: "Created At Start Date",
      type: "date",
      placeholder: "From"
    },
    {
      key: "createdEndDate",
      label: "Created At End Date",
      type: "date",
      placeholder: "To"
    },
    {
      key: "publishedStartDate",
      label: "Published At Start Date",
      type: "date",
      placeholder: "From"
    },
    {
      key: "publishedEndDate",
      label: "Published At End Date",
      type: "date",
      placeholder: "To"
    }
  ];
};
